import { render, staticRenderFns } from "./CallDetails.vue?vue&type=template&id=0492e41f&scoped=true"
import script from "./CallDetails.vue?vue&type=script&lang=js"
export * from "./CallDetails.vue?vue&type=script&lang=js"
import style0 from "./CallDetails.vue?vue&type=style&index=0&id=0492e41f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492e41f",
  null
  
)

export default component.exports